import { useQuery } from '@tanstack/react-query';

import { getTagsByCategory } from '@arrived/api_v2';
import { Tag, TagCategory } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions, UseQueryResult } from '../queries.utils';
import { tagsByCategoryQueryKeyFn } from './tags.keys';

export function useGetTagsByCategoryQuery(
  tagCategory: TagCategory,
  options?: UseQueryOptions<Tag[]>
): UseQueryResult<Tag[]> {
  return useQuery(tagsByCategoryQueryKeyFn(tagCategory), async () => getTagsByCategory(tagCategory), {
    ...options,
    staleTime: options?.staleTime ?? MAX_STALE_TIME,
    enabled: options?.enabled ?? true,
  });
}
